import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import { connect } from '../../../reducers/index';
import { url } from '../../../constants/routes';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';

import './styles.css';
// import ReferGraphic from '../img/refer-graphic.svg';

const ReferPage = props => {
  return (
    <EducationModuleLayout
      progressStage={6}
      childTitle="Refer"
      progressType="refer"
    >
      <section className="no-bottom-padding">
        <div className="container">
          <Row className="text-center">
            <Col xs={10} xsOffset={1}>
              <h2 className="txt-blue no-bold no-margin">
                4. Follow up
              </h2>
            </Col>
          </Row>
          <Row>
            <Col xs={10} xsOffset={1}>
              <p>
                Once enough time has passed for the person to have possibly acted upon your referrals,
                it’s often appropriate to check in with them to see if the situation has improved. In following up,
                it’s important to continue to respect their privacy, particularly regarding personal health information.
                Although they may volunteer to share additional information, they shouldn’t feel expected to. Depending on
                the actions they’ve taken, you may want to review the resources you initially discussed or suggest
                additional ones. Following up could sound like, <span style={{ fontStyle: 'italic' }}>“Just checking in;
                I have learned of some other resources if you’d like them.”</span>
              </p>
            </Col>
          </Row>
        </div>
      </section>
      <section>
        <div className="container text-center">
          <Row>
            <Col xs={12}>
              <Button
                className="btn btn-blue previous"
                onClick={() => props.history.goBack()}
              >
                Previous
              </Button>
              <LinkContainer to={url.REFER_G} className="btn btn-blue next">
                <Button>Next</Button>
              </LinkContainer>
            </Col>
          </Row>
        </div>
      </section>
    </EducationModuleLayout>
  );
};

ReferPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const ReferF = connect.role(ReferPage);

export default ReferF;



// WEBPACK FOOTER //
// ./src/containers/Refer/ReferF/index.jsx